// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Centered stack */
.toast-stack {
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  gap: 0;
  align-items: center;
  z-index: 9999;
  pointer-events: none;
}

/* Base toast in stack: start collapsed */
.toast-stack .toast-container {
  position: static;
  display: inline-flex;
  align-items: center;
  background-color: var(--dialog-background-color);
  gap: var(--overlay-panel-element-gap);
  padding: var(--overlay-panel-padding);
  border-radius: var(--dialog-border-radius);
  box-shadow: 0 6px 16px rgba(0,0,0,.15);
  pointer-events: auto;
  overflow: hidden;

  /* animation props */
  max-height: 0;
  margin-top: 0;
  opacity: 0;
  padding-block: 0;
  transition:
    max-height .28s ease,
    margin-top .28s ease,
    opacity .2s ease,
    padding-block .28s ease
}

/* Open (entered) */
.toast-stack .toast-container.toast--open {
  max-height: 240px;
  margin-top: 8px;
  opacity: 1;
  padding-block: var(--overlay-panel-padding);
}

/* Closing (exit) */
.toast-stack .toast-container.toast--closing {
  max-height: 0;
  margin-top: 0;
  opacity: 0;
  padding-block: 0;
}

.toast-close-icon { color: var(--border-color); }
`, "",{"version":3,"sources":["webpack://./src/ui/components/toast/Toast.component.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gDAAgD;EAChD,qCAAqC;EACrC,qCAAqC;EACrC,0CAA0C;EAC1C,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;;EAEhB,oBAAoB;EACpB,aAAa;EACb,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB;;;;;AAKF;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,2CAA2C;AAC7C;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;;AAEA,oBAAoB,0BAA0B,EAAE","sourcesContent":["/* Centered stack */\n.toast-stack {\n  position: fixed;\n  bottom: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  align-items: center;\n  z-index: 9999;\n  pointer-events: none;\n}\n\n/* Base toast in stack: start collapsed */\n.toast-stack .toast-container {\n  position: static;\n  display: inline-flex;\n  align-items: center;\n  background-color: var(--dialog-background-color);\n  gap: var(--overlay-panel-element-gap);\n  padding: var(--overlay-panel-padding);\n  border-radius: var(--dialog-border-radius);\n  box-shadow: 0 6px 16px rgba(0,0,0,.15);\n  pointer-events: auto;\n  overflow: hidden;\n\n  /* animation props */\n  max-height: 0;\n  margin-top: 0;\n  opacity: 0;\n  padding-block: 0;\n  transition:\n    max-height .28s ease,\n    margin-top .28s ease,\n    opacity .2s ease,\n    padding-block .28s ease\n}\n\n/* Open (entered) */\n.toast-stack .toast-container.toast--open {\n  max-height: 240px;\n  margin-top: 8px;\n  opacity: 1;\n  padding-block: var(--overlay-panel-padding);\n}\n\n/* Closing (exit) */\n.toast-stack .toast-container.toast--closing {\n  max-height: 0;\n  margin-top: 0;\n  opacity: 0;\n  padding-block: 0;\n}\n\n.toast-close-icon { color: var(--border-color); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
